import React, { useEffect, useState } from 'react'

import { TrackingAnalytics } from '../../analytics/TrackingAnalytics'

import { toggleTabs } from '../newDashboardUtils'

const POPinsToggle = ({ defaultFilters, onClick: propsOnClick }) => {
  const [activeIdx, setActiveIdx] = useState(0)

  const localFilter = defaultFilters.toggle
  const defaultIdx = localFilter
    ? toggleTabs.findIndex((tab) => tab.id === localFilter.id)
    : 0

  const onClick = (tab, idx) => () => {
    setActiveIdx(idx)
    if (propsOnClick) propsOnClick('toggle', tab)
    TrackingAnalytics.send(`Dashboard - Created/Joined Toggle Clicked`)
  }

  useEffect(() => {
    setActiveIdx(defaultIdx)
    propsOnClick('toggle', localFilter)
    // eslint-disable-next-line
  }, [localFilter])

  return (
    <div className="popins-toggle">
      {toggleTabs.map((tab, idx) => (
        <div
          key={`popins-toggle-${tab.id}`}
          onClick={onClick(tab, idx)}
          className={tab.className + `${idx === activeIdx ? ' active' : ''}`}
        >
          {tab.text}
        </div>
      ))}
    </div>
  )
}

export default POPinsToggle
